import type { FC } from 'react';

export const PlusIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      x="0.5"
      y="0.5"
      d="M4 1V7M1 4H7"
      stroke={props.color || '#E6E6E9'}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
